var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scars-template',{attrs:{"acne-scars":_vm.acneScars,"acne-scar-causes":_vm.acneScarCauses,"has-acne-scares":_vm.hasAcneScares,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }